"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var ATLAtomIconButton_1 = require("../atoms/ATLAtomIconButton");
var defaultProps = {
    complementary: false,
    iconButtonBaseProps: {}
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.IconButtonWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 99;\n  display: flex;\n  align-self: flex-end;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: ", "px;\n  right: ", "px;\n"], ["\n  z-index: 99;\n  display: flex;\n  align-self: flex-end;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: ", "px;\n  right: ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingMarginal;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingMarginal;
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLFloatingButton = function (_a) {
    var icon = _a.icon, onPress = _a.onPress, complementary = _a.complementary, horizontalMargin = _a.horizontalMargin, verticalMargin = _a.verticalMargin, iconButtonBaseProps = _a.iconButtonBaseProps;
    var theme = ThemeProvider_1.useTheme();
    // Returns complete ATLFloatingButton
    return (react_1.default.createElement(exports.IconButtonWrapper, { horizontalMargin: horizontalMargin, verticalMargin: verticalMargin },
        react_1.default.createElement(ATLAtomIconButton_1.ATLAtomIconButton, __assign({ hasShadow: true, icon: icon, onPress: onPress, buttonColor: complementary ? theme.ColorComplementary1 : theme.ColorBrand1Default, buttonBorderWidth: 0, buttonSize: theme.SizeFloatingButton, iconColor: complementary ? theme.ColorBrand1Default : theme.ColorComplementary1, iconSize: theme.SizeIconBase, buttonBorderRadius: theme.BorderRadiusFloatingButton }, iconButtonBaseProps))));
};
exports.ATLFloatingButton.defaultProps = defaultProps;
exports.ATLFloatingButton.displayName = 'ATLFloatingButton';
var templateObject_1;
